export default __webpack_public_path__ + "static/media/rating_web-md@2x.7ca68bab.webp";